import { getUserId } from '../helpers/cookies';

export const extractChatParticipant = (chat) => {
    if (!chat || !chat.participants) return null;

    const userId = parseInt(getUserId(), 10);

    return chat.participants.find(
        (p) => p.owner && p.owner.id !== userId
    ) || null;
};